import { render } from "./PlansManagerView.vue?vue&type=template&id=a630835c"
import script from "./PlansManagerView.vue?vue&type=script&lang=js"
export * from "./PlansManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__